import Staff from "./Staff";

class Staffs {
  constructor(private readonly _list: Staff[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): Staff[] {
    return this._list;
  }
}

export default Staffs;
